



































import Site from '@/model/Site';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class Changelog extends Vue {
  get site(): Site | null {
    return this.$store.state.site;
  }

  accessImportExport(customerId: string): boolean {
    return this.accessToImportExportCSV(customerId);
  }

  private accessToImportExportCSV(customerId?: string) {
    const customerIds = [
      'demo',
      'Y92',
      'Y57',
      'Z20',
      'A39',
      'A95',
      'A46',
      'A44',
      'A48',
      'B48',
      'Y55',
      'Z07',
      'Z25',
      'A77',
      'X87',
      'A73',
      'A64',
      'A76',
      'A61',
      'A71',
      'A82',
      'A26',
      'R41',
      'B18',
      'Z16',
      'A91',
      'A98',
      'A99',
      'C00a',
      'C00b',
      'C00c',
      'Z22',
      'A57',
      'C10',
      'S16',
      'L19',
      'D14',
      'B13',
      'S13',
      'A45',
      'A69',
      'A70',
      'A27',
      'R52',
    ];
    return customerIds.some(id => id === customerId);
  }
}
